import React, { useState } from 'react';
import {
  FormGroup,
  ModalBody,
  Col,
  Button,
  Label,
  Input,
  Form
} from 'reactstrap';
import rotas from 'services/rotas';
import rest from 'lib/rest';
import Loading from 'lib/loading'
import useForm from '../../../lib/useForm';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FormModeloDesconto = ({ closeModal, descontos }) => {

  const initialForm = {
    nome: "",
    observacao: "",
    descontos: descontos,
  }

  const [form, onChange, setForm] = useForm(initialForm)
  const [loading, setLoading]     = useState(false)

  //SUBMIT
  const SubmitModelo = (evt) => {
    setLoading(true)
    evt.preventDefault()
    console.log(form);
    const url = rotas.convModeloDesconto + 'gravar.php'
    return rest.post(url, form)
      .then(ret => {
        if ((ret.success) && (ret.success == 'S')) {
          formSwal.fire('Salvo!', ret.msg, 'success')
        } else {
          formSwal.fire('Erro!', ret.msg, 'error')
        }
        closeModal()
      })
  }

  if (loading) {
    return (
      <ModalBody className="loadingBody">
        <Loading tipo='componente' />
      </ModalBody>
    )
  } else {
    return (
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0" >
          <Form onSubmit={SubmitModelo}>
            <Col md='12'>
              <FormGroup>
                <Label for="nome">Nome Modelo de Desconto</Label>
                <Input
                  id            = "nome"
                  name          = "nome"
                  placeholder   = "Digite o nome do modelo"
                  onChange      = {onChange('nome')}
                  defaultValue  = {form.nome}
                  maxLength     = {100}
                  required
                />
              </FormGroup>
            </Col>
            <Col md='12'>
              <FormGroup>
                <Input
                  id            = "observacao"
                  name          = "observacao"
                  type          = "textarea"
                  placeholder   = "Digite aqui sua observação..."
                  maxLength     = {250}
                  className     = "form-control"
                  onChange      = {onChange('observacao')}
                  defaultValue  = {form.observacao}
                />
              </FormGroup>
            </Col>
            <Col className="text-center p-3" md='12'>
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button className="mb-0 mt-0" color="default" size="md" onClick={closeModal}>Fechar</Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
    )
  }
}

export default FormModeloDesconto

